import * as c from "./constant";

export const setMagData = (card) => ({
  type: c.SET_DATA,
  card,
});

export const setResetData = () => ({
  type: c.RESET_DATA,
});
